<template lang="pug">
.study-result-detail-image-list
  template(v-for='image in images')
    link-base.study-result-detail-image-list__thumbnail(@click='clickEvent(image)')
      image-base.study-result-detail-image-list__thumbnail__image(:src='image.thumbnail')
      image-base.study-result-detail-image-list__thumbnail__icon(
        :src='require(`@/assets/img/common/icon/${iconName(image)}.svg`)'
      )
      span.study-result-detail-image-list__thumbnail__text(v-if='!image.isSolved') 未実施の問題です
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import LinkBase from '@/components/atoms/LinkBase.vue'
import ImageBase from '@/components/atoms/ImageBase.vue'
import { StudyResultDetailImage } from '@/models/studyResultDetailModel'

/**
 * テスト結果詳細キャプチャ画像一覧
 */
@Component({
  components: {
    LinkBase,
    ImageBase,
  },
})
export default class StudyResultDetailImageList extends Vue {
  // 画像情報
  @Prop()
  images!: StudyResultDetailImage[]

  // 画像クリック時イベント
  @Prop()
  clickEvent!: Function

  // 正否アイコン名
  private iconName(image: StudyResultDetailImage): string {
    return image.isCorrect ? 'correct' : 'wrong'
  }
}
</script>

<style lang="stylus" scoped>
.study-result-detail-image-list
  display flex
  padding 10px 0
  overflow-y scroll
  &__thumbnail
    position relative
    padding 10px
    &__image
      // TODO: 以下は暫定値、サイズが確定したら修正
      width 200px
      height 200px
      max-width unset

    &__icon
      position absolute
      top 15px
      left 15px

    &__text
      color: red
      background: white
      font-weight: bold
      position absolute
      top 15px
      left 50px
</style>
